import { useMsal } from "@azure/msal-react";
import { Stack } from '@fluentui/react/lib/Stack';
import { RouterParams } from 'App';
import { RootState } from 'app/store';
import PageLoading from 'global/PageLoading';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { loadSnapshotAction } from "../../global/Application/dataActions";
import { AppDataSource } from "../../global/DataSources/AppDataSource";
import { MsalTokenSource } from "../../global/DataSources/MsalTokenSource";
import { trimGUIDLower } from "../../global/Utility/TSFunctions";
import { IDateValue, IOptionSetValue, IStringValue } from "../../model/FlexibleAttributeModel";
import { aggregateDataForFees } from "../BlueRelationship/MonthlyRecurringFees";

interface IProps {
}

const SubgroupInformation = (props: IProps) => {
    const state = useSelector((state: RootState) => state);
    const {id, snapshotId} = useParams<RouterParams>();
    const dispatch = useDispatch();
    const {instance} = useMsal();
    const tokenSource = new MsalTokenSource(instance);
    const dataSource = new AppDataSource(tokenSource);
    useEffect(() => {
debugger
        if (id && snapshotId) {

            let reload = false;

            if (!reload)
                if (!state.status.snapshotLoading)
                    if (!state?.data?.snapshot?.bcbs_groupconfigurationsnapshotid)
                        reload = true;

            if (!reload)
                if (state.status.account &&
                    state.data?.snapshot?.bcbs_groupconfigurationsnapshotid &&
                    trimGUIDLower(state.data.snapshot.bcbs_groupconfigurationsnapshotid!) !== trimGUIDLower(snapshotId)
                )
                    reload = true;

            if (!reload)
                if (state.status.account &&
                    state.data.snapshot?.bcbs_groupconfigurationsnapshotid &&
                    trimGUIDLower(state.status.account?.accountid!) !== trimGUIDLower(id)
                )
                    reload = true;

            if (reload)
                dispatch(loadSnapshotAction(dataSource,
                    id!,
                    { primarySnapshotId: snapshotId }
                ));
        }
        else {
            console.error("Unexpected flow, snapshotId or accountId was expected.")
        }
    }, []);

    const contCode = useMemo(() => state.data.json?.fields?.find(f => f.masterAttributeID === state.data?.config?.masterattributes?.find(c => c.bcbs_logicalname === "Bcbs_ContributionCode")?.bcbs_config_masterattributeid)?.values[0]?.value as IStringValue, [state.data.json]);

    const recurringFees = useMemo(() => state.data.json?.plans?.map((p) => {
    const fp = state.data.json?.feesAndPremiums?.find(f => f.id === p.feesAndPremiumsRef?.id);
    let fees = fp && aggregateDataForFees(state.data.config, fp);
    const med = fees?.items?.find(f => f?.category === "Medical")
    const dental = fees?.items?.find(f => f?.category === "Dental")
    const vision = fees?.items?.find(f => f?.category === "Vision")
    const currency = Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
        });

        return {id: p.id,
        medical: {
            employeeonly: med?.['Employee Only Rate'] ? currency.format(parseFloat(med?.['Employee Only Rate'])) : "N/A",
            familyrate: med?.["Family Rate"]? currency.format(parseFloat(med?.['Family Rate'])) : "N/A",
            employeechildren: med?.["Employee + Child(ren) Rate"] ? currency.format(parseFloat(med?.['Employee + Child(ren) Rate'])) : "N/A",
            employeespouse: med?.["Employee + Spouse Rate"] ? currency.format(parseFloat(med?.['Employee + Spouse Rate'])) : "N/A",
            employee1: med?.["Employee + 1 (Child) Rate"] ? currency.format(parseFloat(med?.['Employee + 1 (Child) Rate'])) : "N/A",
            twoperson: med?.["Two-Person Rate"] ? currency.format(parseFloat(med?.['Two-Person Rate'])) : "N/A",
            employee2: med?.["Employee + 2 Dependents Rate"] ? currency.format(parseFloat(med?.['Employee + 2 Dependents Rate'])) : "N/A"
        },
        dental: {
            employeeonly: dental?.['Employee Only Rate'] ? currency.format(parseFloat(dental?.['Employee Only Rate'])) : "N/A",
            familyrate: dental?.["Family Rate"] ? currency.format(parseFloat(dental?.['Family Rate'])) : "N/A",
            employeechildren: dental?.["Employee + Child(ren) Rate"] ? currency.format(parseFloat(dental?.['Employee + Child(ren) Rate'])) : "N/A",
            employeespouse: dental?.["Employee + Spouse Rate"]  ? currency.format(parseFloat(dental?.['Employee + Spouse Rate'])) : "N/A",
            employee1: dental?.["Employee + 1 (Child) Rate"] ? currency.format(parseFloat(dental?.['Employee + 1 (Child) Rate'])) : "N/A",
            twoperson: dental?.["Two-Person Rate"]  ? currency.format(parseFloat(dental?.['Two-Person Rate'])) : "N/A",
            employee2: dental?.["Employee + 2 Dependents Rate"] ? currency.format(parseFloat(dental?.['Employee + 2 Dependents Rate'])) : "N/A"
        },
        vision: {
            employeeonly: vision?.['Employee Only Rate'] ? currency.format(parseFloat(vision?.['Employee Only Rate'])) : "N/A",
            familyrate: vision?.["Family Rate"] ? currency.format(parseFloat(vision?.['Family Rate'])) : "N/A",
            employeechildren: vision?.["Employee + Child(ren) Rate"] ? currency.format(parseFloat(vision?.['Employee + Child(ren) Rate'])) : "N/A",
            employeespouse: vision?.["Employee + Spouse Rate"]  ? currency.format(parseFloat(vision?.['Employee + Spouse Rate'])) : "N/A",
            employee1: vision?.["Employee + 1 (Child) Rate"] ? currency.format(parseFloat(vision?.['Employee + 1 (Child) Rate'])) : "N/A",
            twoperson: vision?.["Two-Person Rate"]  ? currency.format(parseFloat(vision?.['Two-Person Rate'])) : "N/A",
            employee2: vision?.["Employee + 2 Dependents Rate"] ? currency.format(parseFloat(vision?.['Employee + 2 Dependents Rate'])) : "N/A"
        }
    }

}), [state.data.json?.plans]);

const tdstyles = {
    minHeight: '30px',
    border: '1px solid black',
    borderCollapse: 'collapse',
    padding: '5px',
    verticalAlign: 'top',
    borderSpacing: '0'
} as React.CSSProperties;
const thstyles = {
    border: '1px solid black',
    borderCollapse: 'collapse',
    padding: '5px',
    verticalAlign: 'top',
borderSpacing: '0'} as React.CSSProperties;

   const CESGroupMasterAttribute = state.data?.config?.masterattributes?.find(c => c.bcbs_logicalname === "Bcbs_SubgrpCESGroup");
    const groupTitleMasterAttribute = state.data?.config?.masterattributes?.find(c => c.bcbs_logicalname === "Bcbs_SubgrpDescription");
    const effDateMasterAttribute = state.data?.config?.masterattributes?.find(c => c.bcbs_logicalname === "Bcbs_EffectiveDate");
    const outOfStateMasterAttribute = state.data?.config?.masterattributes?.find(c => c.bcbs_logicalname === "bcbs_subgrouplocation");
    const groupLeaderMasterAttribute = state.data?.config?.masterattributes?.find(c => c.bcbs_logicalname === "bcbs_groupleaderid");
    const alphaPrefixMasterAttribute = state.data?.config?.masterattributes?.find(c => c.bcbs_logicalname === "Bcbs_AlphaPrefix");
    const controlCodesMasterAttribute = state.data?.config?.masterattributes?.find(c => c.bcbs_logicalname === "Bcbs_ControlCodes");
    const prob1MasterAttribute = state.data?.config?.masterattributes?.find(c => c.bcbs_logicalname === "bcbs_probationaryperiod1id");
    const prob2MasterAttribute = state.data?.config?.masterattributes?.find(c => c.bcbs_logicalname === "bcbs_probationaryperiod2id");
    const prob3MasterAttribute = state.data?.config?.masterattributes?.find(c => c.bcbs_logicalname === "bcbs_probationaryperiod3id");
    const probCustomMasterAttribute = state.data?.config?.masterattributes?.find(c => c.bcbs_logicalname === "Bcbs_ProbationaryPeriodCustom");
const tableStyle={
    root: {
        'tr:nth-child(3), tr:nth-child(1), tr:nth-child(4)': {backgroundColor: '#CCCCCC'},
        table: {borderBottom: '3px solid black'}
    }
}
    return (
        <>
            <div style={{minWidth: '98%', maxWidth:'98%', marginLeft: 'auto', marginRight: 'auto'}}>

                {!state.status.snapshotLoading
                    ? <>
                        {state.data?.json?.groupStructure?.cesNumbers.filter(c => !c.deactivated).map(cesNumber => {
                            const gns = state.data?.json?.groupStructure?.groupNumbers?.filter(g => !g.deactivated && g.cesNumberRef?.id === cesNumber.id)?.sort((first, second)=>{
                                  const firstVal = `${first?.prefix?.toString()}${first?.base?.toString()}${first?.suffix?.toString()}`;
                                  const secondVal = `${second?.prefix?.toString()}${second?.base?.toString()}${second?.suffix?.toString()}`;
                                    debugger
                                  return firstVal > secondVal ? 1 : -1;

                            });

                            return <Stack>
                                <Stack.Item style={{fontWeight: 'bold', padding: '20px'}} align="stretch">CES Client # {cesNumber.cesNumber}</Stack.Item>
                                        {

                                            gns.map(groupNumber => {
                                        const CESGroup = groupNumber.fields.find(f => f.masterAttributeID === CESGroupMasterAttribute?.bcbs_config_masterattributeid)?.values[0]?.value as IStringValue;
                                        const groupTitle = groupNumber.fields.find(f => f.masterAttributeID === groupTitleMasterAttribute?.bcbs_config_masterattributeid)?.values[0]?.value as IStringValue;
                                        const effDate = groupNumber.fields.find(f => f.masterAttributeID === effDateMasterAttribute?.bcbs_config_masterattributeid)?.values[0]?.value as IDateValue;
                                        const outOfState = groupNumber.fields.find(f => f.masterAttributeID === outOfStateMasterAttribute?.bcbs_config_masterattributeid)?.values[0]?.value as IStringValue;
                                        const groupLeader = groupNumber.fields.find(f => f.masterAttributeID === groupLeaderMasterAttribute?.bcbs_config_masterattributeid)?.values[0]?.value as IStringValue;
                                        const alphaPrefix = groupNumber.fields.find(f => f.masterAttributeID === alphaPrefixMasterAttribute?.bcbs_config_masterattributeid)?.values[0]?.value as IStringValue;
                                        const controlCodes = groupNumber.fields.find(f => f.masterAttributeID === controlCodesMasterAttribute?.bcbs_config_masterattributeid)?.values[0]?.value as IStringValue;
                                        const prob1 = groupNumber.fields.find(f => f.masterAttributeID === prob1MasterAttribute?.bcbs_config_masterattributeid)?.values[0]?.value as IOptionSetValue;
                                        const prob2 = groupNumber.fields.find(f => f.masterAttributeID === prob2MasterAttribute?.bcbs_config_masterattributeid)?.values[0]?.value as IOptionSetValue;
                                        const prob3 = groupNumber.fields.find(f => f.masterAttributeID === prob3MasterAttribute?.bcbs_config_masterattributeid)?.values[0]?.value as IOptionSetValue;
                                        const probCustom = groupNumber.fields.find(f => f.masterAttributeID === probCustomMasterAttribute?.bcbs_config_masterattributeid)?.values[0]?.value as IStringValue;


                                            return <Stack.Item align="stretch">
                                                <table style={ {borderBottom: '3px solid black', borderCollapse: 'collapse',padding: '5px'}}> <tr style={{backgroundColor: '#CCCCCC'}}>
                                                <th style={thstyles}>
                                                    AMMS Group #
                                                </th>
                                                <th style={thstyles}>
                                                    Suffix
                                                </th>
                                                <th style={thstyles}>
                                                    CES Group #
                                                </th>
                                                <th style={thstyles}>
                                                    Group Title
                                                </th>
                                                <th style={thstyles}>
                                                    Eff Date
                                                </th>
                                                <th style={thstyles}>
                                                    Out of State
                                                </th>
                                                <th style={thstyles}>
                                                    Grp Leader Name
                                                </th>
                                                <th style={thstyles}>
                                                    Alpha Prefix
                                                </th>
                                                <th style={thstyles}>
                                                    Contribution Code
                                                </th>
                                                <th style={thstyles}>
                                                    Probationary Prd 1
                                                </th>
                                                <th style={thstyles}>
                                                    Prd 2
                                                </th>
                                                <th style={thstyles}>
                                                    Prd 3
                                                </th>
                                                <th style={thstyles}>
                                                    PP Custom
                                                </th>
                                                <th style={thstyles}>
                                                    Control Code
                                                </th>
                                                <th style={thstyles}></th>
                                                <th style={thstyles}></th>

                                                <th style={thstyles}></th>
                                                <th style={thstyles}></th>

                                                <th style={thstyles}></th>
                                                <th style={thstyles}></th>

                                                <th style={thstyles}></th></tr>
                                            <tr><td style={tdstyles}>
                                                {groupNumber.prefix}-{groupNumber.base}
                                            </td>
                                            <td style={tdstyles}>
                                                {groupNumber.suffix}
                                            </td>
                                            <td style={tdstyles}>
                                                {CESGroup?.value}
                                            </td>
                                            <td style={tdstyles}>
                                                {groupTitle?.value}
                                            </td>
                                            <td style={tdstyles}>
                                                {effDate?.value}
                                            </td>
                                            <td style={tdstyles}>
                                                {outOfState?.value}
                                            </td>
                                            <td style={tdstyles}>
                                                {groupLeader?.value}
                                            </td>
                                            <td style={tdstyles}>
                                                {alphaPrefix?.value}
                                            </td>
                                            <td style={tdstyles}>
                                                {contCode?.value}
                                            </td>
                                            <td style={tdstyles}>
                                                {prob1?.name}
                                            </td>
                                            <td style={tdstyles}>

                                                {prob2?.name}
                                            </td>
                                            <td style={tdstyles}>

                                                {prob3?.name}
                                            </td>
                                            <td style={tdstyles}>

                                                {probCustom?.value}
                                            </td>
                                                <td style={tdstyles}>
                                                    {controlCodes?.value}
                                                </td>
                                            <td style={tdstyles}></td>
                                            <td style={tdstyles}></td>

                                            <td style={tdstyles}></td>
                                            <td style={tdstyles}></td>

                                            <td style={tdstyles}></td>
                                            <td style={tdstyles}></td>

                                            <td style={tdstyles}></td>
                                        </tr>
                                            <tr style={{backgroundColor: '#CCCCCC'}}>
                                                <th style={thstyles} colSpan={7}>Medical</th>
                                                <th style={thstyles}  colSpan={7}>Dental</th>
                                                <th style={thstyles} colSpan={7}>Vision</th>
                                            </tr>
<tr style={{backgroundColor: '#CCCCCC'}}>
    <td style={tdstyles}>Employee Only Rate<br/>
    </td>
    <td style={tdstyles}>
        Family Rate<br/>
    </td>

    <td style={tdstyles}>Employee + Child(ren) Rate<br/>
    </td>
    <td style={tdstyles}>Employee + Spouse Rate<br/>
    </td>

    <td style={tdstyles}>Employee + 1 (Child) Rate<br/>
    </td>
    <td style={tdstyles}>
        Two-Person Rate<br/>

    </td>
    <td style={tdstyles}>Employee + 2 Dependents Rate<br/>
    </td>
    <td style={tdstyles}>Employee Only Rate<br/>
    </td>
    <td style={tdstyles}>
        Family Rate<br/>
    </td>

    <td style={tdstyles}>Employee + Child(ren) Rate<br/>
    </td>
    <td style={tdstyles}>Employee + Spouse Rate<br/>
    </td>

    <td style={tdstyles}>Employee + 1 (Child) Rate<br/>
    </td>
    <td style={tdstyles}>
        Two-Person Rate<br/>

    </td>
    <td style={tdstyles}>Employee + 2 Dependents Rate<br/>
    </td>
    <td style={tdstyles}>Employee Only Rate<br/>
    </td>
    <td style={tdstyles}>
        Family Rate<br/>
    </td>

    <td style={tdstyles}>Employee + Child(ren) Rate<br/>
    </td>
    <td style={tdstyles}>Employee + Spouse Rate<br/>
    </td>

    <td style={tdstyles}>Employee + 1 (Child) Rate<br/>
    </td>
    <td style={tdstyles}>
        Two-Person Rate<br/>

    </td>
    <td style={tdstyles}>Employee + 2 Dependents Rate<br/>
    </td>
</tr><tr>
    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.medical.employeeonly ?? "N/A"}
    </td>
    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.medical.familyrate ?? "N/A"}
    </td>

    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.medical.employeechildren ?? "N/A"}
    </td>
    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.medical.employeespouse ?? "N/A"}
    </td>

    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.medical.employee1 ?? "N/A"}
    </td>
    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.medical.twoperson ?? "N/A"}

    </td>
    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.medical.employee2 ?? "N/A"}
    </td>
    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.dental.employeeonly ?? "N/A"}
    </td>
    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.dental.familyrate ?? "N/A"}
    </td>

    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.dental.employeechildren ?? "N/A"}
    </td>
    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.dental.employeespouse ?? "N/A"}
    </td>

    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.dental.employee1 ?? "N/A"}
    </td>
    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.dental.twoperson ?? "N/A"}

    </td>
    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.dental.employee2 ?? "N/A"}
    </td>
    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.vision.employeeonly ?? "N/A"}
    </td>
    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.vision.familyrate ?? "N/A"}
    </td>

    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.vision.employeechildren ?? "N/A"}
    </td>
    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.vision.employeespouse ?? "N/A"}
    </td>

    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.vision.employee1 ?? "N/A"}
    </td>
    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.vision.twoperson ?? "N/A"}

    </td>
    <td style={tdstyles}>
        {recurringFees.find(p => p.id === groupNumber.planRef?.id)?.vision.employee2 ?? "N/A"}
    </td>
</tr></table> </Stack.Item>
                                        })}
                               </Stack>
                        })}
                    </>
                    : <PageLoading/>
                }
            </div>
        </>
    );


}

export default SubgroupInformation;
